import List from "./list/PluginSetup.js";
import Table from "./table/PluginSetup.js";
import Details from "./details/PluginSetup.js";
import TableList from "./tableList/PluginSetup.js";
import Dashboard from "./dashboard/PluginSetup.js";
import Aggregations from "./aggregations/PluginSetup.js";
import Actions from "./actions/PluginSetup.js";
import Layout from "./layout/PluginSetup.js";
import Map from "./map/mapbox/PluginSetup.js";
import GoogleMap from "./map/googleMap/PluginSetup.js";
import Overrides from "./overrides/PluginSetup.js";
import History from "./history/PluginSetup.js";
import OperatingHours from "./operatingHours/PluginSetup.js";
import SharedSetup from "./map/shared/PluginSetup.js";
import Converters from "./converter/PluginSetup.js";
import PieChart from "./pieChart/PluginSetup.js";
const install = molten => {
  Aggregations.install(molten);
  Dashboard.install(molten);
  Details.install(molten);
  List.install(molten);
  PieChart.install(molten);
  Table.install(molten);
  TableList.install(molten);
  Actions.install(molten);
  Layout.install(molten);
  Map.install(molten);
  GoogleMap.install(molten);
  Overrides.install(molten);
  History.install(molten);
  OperatingHours.install(molten);
  SharedSetup.install(molten);
  Converters.install(molten);
};
export default {
  install
};